import React from 'react'
import { Helmet } from 'react-helmet'
import splash from '../../media/classroomSplash.jpg'
import { ReactComponent as QuoteIcon } from '../../media/icon-science.svg'
import oftmcssLogo from '../../media/oftmcss.svg'
import { Brand, Content, Templates } from 'ui'
import * as Forms from './Forms'
import { randomTestimonial } from './testimonials'

/**
 * A basic login form to sign into the application (applies to all user types).
 */
export const ConfirmAccountView: React.FC = () => {
  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Confirm Your Account - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Confirm Your Account</Content.Heading>
        <Content.Body>
          Before we get started building your profile, let’s confirm your
          account and setup a memorable password.
        </Content.Body>
        <Forms.ConfirmAccount />
      </Content.Region>
    </Templates.SplashImageView>
  )
}
